'use client'
import { Formik, Form } from 'formik'
import { useTranslations } from 'next-intl'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { useKnowledgeSourceMutation } from '@/hooks/mutations/knowledge-sources'

export function KnowledgeSourceDisconnectDialog({ connectionId, onClose }: { connectionId: string; onClose(): void }) {
  const t = useTranslations('KnowledgeSources')
  const mutation = useKnowledgeSourceMutation()
  return <Dialog open onOpenChange={open => { if (!open) onClose() }}><DialogContent>
    <DialogHeader><DialogTitle><span>{t('disconnect')}</span></DialogTitle><DialogDescription><span>{t('disconnectWarning')}</span></DialogDescription></DialogHeader>
    <Formik initialValues={{ connectionId }} onSubmit={values => mutation.mutateAsync({ kind: 'disconnect', connectionId: values.connectionId }).then(onClose).catch(() => {})}>
      {({ isSubmitting }) => <Form className="flex flex-wrap justify-end gap-2">
        <Button variant="outline" type="button" onClick={onClose}><span>{t('cancel')}</span></Button>
        <Button variant="destructive" type="submit" disabled={isSubmitting}><span>{t('disconnect')}</span></Button>
      </Form>}
    </Formik>
  </DialogContent></Dialog>
}
